export const ACTION_MESSAGE_REPLY = 1;
export const ACTION_MESSAGE_COPY = 2;
export const ACTION_MESSAGE_EDIT = 3;
export const ACTION_MESSAGE_PIN_NOTE = 4;
export const ACTION_MESSAGE_FORWARD = 5;
export const ACTION_MESSAGE_DELETE = 6;
export const ACTION_MESSAGE_MORE = 7;
export const ACTION_MESSAGE_DOWNLOAD = 8;
